import { useEffect, useRef, useState } from "react";
import { useLang, REGIONS } from "@/lib/i18n";
import { ChevronDown, Check } from "lucide-react";
import Flag from "@/components/Flag";

export default function RegionSwitcher() {
  const { region, setRegion, regionInfo } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button data-testid="region-switcher-btn" onClick={() => setOpen(!open)}
        className="h-9 px-2.5 rounded-full border border-slate-200 bg-white text-xs font-semibold text-slate-600 inline-flex items-center gap-1.5 hover:border-teal-300 transition-colors">
        <Flag code={regionInfo.code} className="w-5 h-3.5 rounded-[2px]" />
        <span className="hidden md:inline">{regionInfo.name}</span>
        <ChevronDown size={13} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div data-testid="region-dropdown" className="absolute right-0 mt-2 w-52 bg-white rounded-2xl border border-slate-200 shadow-2xl p-1.5 z-[65] max-h-80 overflow-y-auto fade-in">
          <p className="text-[10px] font-bold uppercase tracking-wider text-slate-400 px-3 py-1.5">Select your region</p>
          {REGIONS.map((r) => (
            <button key={r.code} data-testid={`region-option-${r.code}`}
              onClick={() => { setRegion(r.code); setOpen(false); }}
              className={`w-full flex items-center gap-2.5 px-3 py-2 rounded-xl text-sm text-left transition-colors ${r.code === region ? "bg-teal-50 text-teal-900 font-semibold" : "text-slate-600 hover:bg-slate-50"}`}>
              <Flag code={r.code} className="w-6 h-4 rounded-[2px] shrink-0" />
              <span className="flex-1">{r.name}</span>
              {r.code === region && <Check size={14} className="text-teal-700" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
